import RecipientGroupHolder from './model-recipientGroup-holder';
import { defa }             from '../../../defa-object';
import Controller           from '../../poppet/controller';
import RecipientsContainer  from './view-recipients-container';

/**
 * defa.controllers.RecipientController
 * The controller for the RecipientRouter
 * @version 1.3.0
 */
const channelLayout = Bb.Radio.channel( 'layout' ),
	  channelNav    = Bb.Radio.channel( 'nav' ),
	  channelUser   = Bb.Radio.channel( 'user' );

const RecipientController = Controller.extend( {
	
	// ------------------------------------------------
	// Routes
	// ------------------------------------------------

	/**
	 * Shows the unit recipientGroupCollection-interface
	 * @void
	 */
	showUnitRecipients: function ( id ) {
		this.requireRecipientGroups( {
			view     : 'unit:recipients',
			recipientGroupHolderId   : id,
			callback : this.attachRecipientContainer,
			closeLink: {
				event : 'unit:control:notifications',
				params: [ id, ],
			},
		} );
	},
	
	/**
	 * Shows the unit createRecipientGroup-interface
	 * @void
	 */
	showNewUnitRecipients: function ( id ) {
		this.requireRecipientGroups( {
			view     : 'unit:recipient:new',
			recipientGroupHolderId   : id,
			callback : this.attachRecipientContainer,
			closeLink: {
				event : 'unit:recipients',
				params: [ id, ],
			},
		} );
	},
	
	/**
	 * Shows the unit updateRecipientGroup-interface
	 * @void
	 */
	showUnitRecipient: function ( id, subId ) {
		this.requireRecipientGroups( {
			view     : 'unit:recipient',
			recipientGroupHolderId   : id,
			recipientGroupId : subId,
			callback : this.attachRecipientContainer,
			closeLink: {
				event : 'unit:recipients',
				params: [ id, ],
			},
		} );
	},
	
	/**
	 * Shows the unit deleteRecipientGroup-interface
	 * @void
	 */
	showRecipientDelete: function(id, subId){
		this.requireRecipientGroups( {
			view     : 'unit:recipient:delete',
			recipientGroupHolderId   : id,
			recipientGroupId : subId,
			callback : this.attachRecipientContainer,
			closeLink: {
				event : 'unit:recipients',
				params: [ id ],
			},
		} );
	},
	

	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Requests all RecipientGroups for the unit, before calling the callback.
	 * @param {Object} options All the needed options, most importantly a recipientGroupHolderId and a callback function.
	 * @void
	 */
	requireRecipientGroups: function ( options ) {
		this.requireModel( 'RecipientGroupHolder', defa.models, options );
		// this.requireModel( 'Unit', defa.models, options );
		
	},
	
	/**
	 * Creates and displays a RecipientContainer.
	 * @param {Object} options  An object containing all the needed objects for creating, listing and editing
	 *     Unit-information.
	 * @void
	 */
	attachRecipientContainer: function ( options ) {
		options           = options || {};
		options.user      = options.user || channelUser.request( 'model' );
		options.noLogin   = options.noLogin || false;

		
		// if user isn't logged in, and this view isn't a no-login view, route to search.
		if ( channelUser.request( 'is:logged:out' ) && !options.noLogin ) {
			channelNav.trigger( 'user:login', { trigger: true, replace: true, } );
			
			
			// if the user is logged in, play with the subscriptionContainer.
		} else {
			
			let self = options.self || this;
			
			// if the SubscriptionContainer isn't made or is destroyed, create it and attach it's listeners
			if ( !( self.recipientContainer instanceof RecipientsContainer ) || self.recipientContainer.isDestroyed() ) {
				self.recipientContainer = new RecipientsContainer( options );
				
				// if it already exists, just update it's options
			} else {
				self.recipientContainer.settings( options );
			}
			
			// if the container isn't attached yet, attach it to the DOM
			if ( !self.recipientContainer.isAttached() ) {
				channelLayout.request( 'root' ).showChildView( 'main', self.recipientContainer );
			}
		}
	},
	
} );

export default RecipientController;